const normalizeUrl = (value) => {
  if (!value) return "";
  const trimmed = String(value).trim();
  if (!trimmed || trimmed === "/") return "";
  return trimmed.replace(/\/$/, "");
};

export const PRODUCTION_WEB_HOSTS = new Set(["tryvoxara.com", "www.tryvoxara.com"]);

const isLocalhost = (hostname) => {
  return ["localhost", "127.0.0.1", "0.0.0.0"].includes(hostname);
};

export const getBackendBaseUrl = () => {
  if (typeof window !== "undefined") {
    const runtimeUrl = normalizeUrl(window.__VOXARA_CONFIG__?.BACKEND_URL);
    if (runtimeUrl) return runtimeUrl;

    if (!isLocalhost(window.location.hostname)) {
      return normalizeUrl(window.location.origin);
    }
  }

  return normalizeUrl(process.env.REACT_APP_BACKEND_URL);
};

export const getApiBaseUrl = () => {
  const backendBaseUrl = getBackendBaseUrl();

  if (!backendBaseUrl) {
    return "/api";
  }

  if (backendBaseUrl.endsWith("/api")) {
    return backendBaseUrl;
  }

  return `${backendBaseUrl}/api`;
};

export const isProductionWebApp = () => {
  if (typeof window !== "undefined") {
    if (PRODUCTION_WEB_HOSTS.has(window.location.hostname)) {
      return true;
    }
  }

  try {
    const backendBaseUrl = getBackendBaseUrl();
    if (!backendBaseUrl) return false;
    const parsed = new URL(backendBaseUrl);
    return PRODUCTION_WEB_HOSTS.has(parsed.hostname);
  } catch (_error) {
    return false;
  }
};